import { EmailVerificationToken } from '@/core/models/email-verification-token.model';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class HasValidURLTokenGuard implements CanActivate {
    protected routeSnapshot: ActivatedRouteSnapshot;
    protected emailVerificationToken: EmailVerificationToken;
    protected router: Router;
    protected fallbackUrl: "login" | "preregister" | "mailverification";

    constructor(router: Router) {
        this.router = router;
    }

    canActivate(routeSnapshot: ActivatedRouteSnapshot) {
        this.routeSnapshot = routeSnapshot;

        this.detectPage();

        if (! this.routeSnapshot.queryParams.token)
            this.handleMissingToken();

        this.setEmailVerificationToken();

        return true;
    }

    /**
     * Try to set the email verification token. If it fails
     * because the token is perhaps invalid and cannot
     * be set, then redirect to the preregister page.
     * 
     * ToDo: Show a message to the user.
     * 
     * @returns void
     */
    protected setEmailVerificationToken(): void {
        try {
            this.emailVerificationToken = new EmailVerificationToken(this.routeSnapshot.queryParams.token);
        } catch {
            this.redirectToFallback();
        }
    }

    /**
     * If no token is present, redirect to the preregister page.
     * 
     * @returns boolean
     */
    protected handleMissingToken(): boolean {
        this.redirectToFallback();
        return false;
    }

    /**
     * Redirect to the fallback page.
     * 
     * @returns void
     */
    protected redirectToFallback(): void {
        this.router.navigate(['/authentication/' + this.fallbackUrl]);
    }

    /**
     * Detect the page and set the fallback url.
     * 
     * @returns void
     */
    protected detectPage(): void {
        if (this.routeSnapshot.routeConfig == null) {
            this.setFallbackUrl("login");
            return;
        }

        if (this.routeSnapshot.routeConfig.path == "register")
            this.setFallbackUrl("preregister");

        if (this.routeSnapshot.routeConfig.path == "resetpassword")
            this.setFallbackUrl("mailverification");
    }

    /**
     * Set the fallback url.
     * 
     * @param fallbackUrl
     */
    protected setFallbackUrl(fallbackUrl: "login" | "preregister" | "mailverification"): void {
        this.fallbackUrl = fallbackUrl;
    }
}
